'use strict';

angular.module('theme').service('SupplementService', function ($q, $http, ArticleService) {

	var self = this;
	var availableSupplements = ['oil'];
	var listCache;

	this.list = function () {
		if (listCache) {
			return listCache;
		}

		listCache = $http({
			url: '/wp-json/mk/supplements',
			method: 'GET',
			cache: true
		}).then(function (response) {
			listCache = undefined;
			return response.data;
		});

		return listCache;
	};

	this.get = function (supplementId) {
		if (!supplementId) {
			return $q.reject('supplementId cannot be null');
		}

		return this.list().then(function (supplements) {
			return _.find(supplements, {supplement_id: supplementId});
		});
	};


	/**
	 * Return an array of allowed supplements with their name, info, number and price
	 * @param order
	 */
	this.getForOrder = function (order) {

		if (!order) {
			return $q.when([]);
		}

		var viewableSupplements = _.compact(_.map(order.supplements, function (value, key) {
			// If the number is 0 we don't return it
			if (value == 0) {
				return false;
			}

			// If the supplement key (oil) isn't a viewable supplement we remove them
			if (!_.includes(availableSupplements, key)) {
				return false;
			}

			return {
				supplementId: key,
				number: value
			};
		}));

		// We have no supplements
		if (viewableSupplements.length === 0) {
			return $q.when([]);
		}

		var promiseArray = _.map(viewableSupplements, function (supplement) {
			return self.get(supplement.supplementId)
				// Convert to DTO
				.then(function (supplementInfo) {
					return {
						id: supplement.supplementId,
						title: supplementInfo.title,
						image: supplementInfo.supplement_image,
						url: supplementInfo.url,
						number: supplement.number,
						price: 0
					};
				})
				// Now we hook onto the articletypes api to get the price
				.then(function (supplement) {
					return ArticleService.getSupplementPrice(order.type, supplement.id, supplement.number).then(function (price) {
						supplement.price = price * supplement.number;
						return supplement;
					});
				});
		});

		return $q.all(promiseArray);
	};

});
